<template>
  <div>
    <ProjectBaseView>
      <div class="body-div" ref="pdfContent">
        <div class="meeting-div">
          <div class="fila0">
            <h1 style="font-size: 2.5em;text-align: center; font-weight: bold;">
              Proyecto: 
              {{ this.$store.state.subprojects.find(e => e._id == meeting.project)?.name || this.$store.state.project?.name || 'Sin nombre' }}
            </h1>
            <h2 style="font-size: 1.8em;text-align: center;">
              {{ meeting.number }}. {{ meeting.name }}
            </h2>
          </div>

          <!-- Barra de progreso (ciclo de vida) -->
          <div style="display: flex; justify-content: center; align-items: center">
            <!-- Devolver el estado de la reunión -->
            <div v-if="mode === 'development'">
              <v-btn color="red" @click="updateMeetingState('back')" v-if="state == 'post-meeting'">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </div>


            <!-- Barra de ciclo de vida -->
            <LifeTimeComponent :step="step" style="width: 50vw" />

            <!-- Todo: Poner un TOOLTIP A ESTO y hacerlo componente -->
            <template v-if="isAnfitrion || isSecretario">
              <!-- Pre-meeting -->
              <template v-if="state == 'new'">
                <v-tooltip text="Ir a la reunión previa" location="bottom">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" @click="goToPreMeeting" class="green">
                      <v-icon color="white">mdi-arrow-right</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </template>

              <!-- In-meeting / Post-meeting -->
              <template v-else-if="state !== 'new' && state !== 'finish'">
                <v-tooltip text="Continuar reunión" location="bottom">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" @click="updateMeetingState" class="green">
                      <v-icon color="white">mdi-arrow-right</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </template>

              <!-- Finalizado -->
            </template>
            
            <template v-if="state == 'finish'">
              <v-tooltip text="Descargar acta" location="bottom">
                <template #activator="{ props }">
                  <v-btn v-bind="props" @click="exit" class="green">
                    <v-icon color="white">mdi-download</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </template>

          </div>


          <!-- Encabezado de la reunión -->
          <MeetingDataComponent :meetingMinute="meetingminute" :state="state" />

          <!-- Pre-In-Post Meeting -->
          <div>
            <v-slide-x-transition>
              <PreMeetingComponent max-width="70vw" v-if="state === 'pre-meeting'" :meeting="meeting"
                :meetingMinute="meetingMinute" />
            </v-slide-x-transition>

            <!-- In-meeting -->
            <v-slide-x-transition>
              <InMeetingComponent max-width="70vw" v-if="state === 'in-meeting'" :meeting="meeting"
                :meetingMinute="meetingminute" :users="users_map" />
            </v-slide-x-transition>

            <!-- Post-meeting -->
            <v-slide-x-transition>
              <!-- Post-meeting (se agrega referencia para exportar el desarrollo de la reunión a PDF)-->
              <PostMeetingComponent max-width="70vw" v-if="state === 'post-meeting' || state === 'finish'"
                :meeting="meeting" ref="postMeetingComponent" />
            </v-slide-x-transition>
          </div>
        </div>
      </div>
    </ProjectBaseView>
  </div>
</template>

<script>
import LifeTimeComponent from "@/components/project/meetingminute/LifeTimeComponent.vue";
import PreMeetingComponent from "@/components/project/meetingminute/PreMeetingComponent.vue";
import api from '@/api.js';
import { gapi } from 'gapi-script';
import MeetingDataComponent from "@/components/project/meetingminute/MeetingDataComponent.vue";
import InMeetingComponent from "@/components/project/meetingminute/InMeetingComponent.vue";
import PostMeetingComponent from "@/components/project/meetingminute/PostMeetingComponent.vue";
//import html2pdf from "html2pdf.js";
import jsPDF from 'jspdf';
import ProjectBaseView from "./ProjectBaseView.vue";
import { formatDateTimeToTime } from "@/utils/globalFunctions";

export default {
  name: "ProjectMeetingView",
  components: {
    LifeTimeComponent,
    PreMeetingComponent,
    MeetingDataComponent,
    InMeetingComponent,
    PostMeetingComponent,
    ProjectBaseView,
  },
  computed: {
    mode() {
      return this.$store.state.node_env;
    },
    project() {
      return this.$store.state.project || null;
    },
    isSecretario() {
      return this.meeting.secretario === localStorage.getItem("email");
    },
    isAnfitrion() {
      return this.meeting.anfitrion === localStorage.getItem("email");
    },
    // Mapea el meeting.state (que es string) a un numero entero del 0 al 4
    step() {
      return {
        new: 0,
        "pre-meeting": 1,
        "in-meeting": 2,
        "post-meeting": 3,
        finish: 4,
      }[this.meeting.state];
    },
    state() {
      return this.meeting.state;
    }
  },
  data() {
    return {
      meeting: {},
      meetingminute: {},
      lista_estados: ["new", "pre-meeting", "in-meeting", "post-meeting", "finish"],
      users: [],
      users_map: null,

      // Google calendar
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
      isAuthenticated: false,
      scope: "https://www.googleapis.com/auth/calendar.events",
    };
  },
  methods: {
    async loadGoogleAPI() {
      gapi.load("client:auth2", () => {
        gapi.client
          .init({
            apiKey: this.apiKey,
            clientId: this.clientId,
            discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"],
            scope: this.scope,
          })
          .then(() => {
            this.isAuthenticated = gapi.auth2.getAuthInstance().isSignedIn.get();
          })
          .catch((error) => {
            console.error("Error al inicializar Google API:", error);
          });
      });
    },
    async authenticateGoogle() {
      const authInstance = gapi.auth2.getAuthInstance();
      if (!authInstance.isSignedIn.get()) {
        await authInstance.signIn();
      }
      this.isAuthenticated = authInstance.isSignedIn.get();
    },
    async addToGoogleCalendar(idMeeting) {
      await this.authenticateGoogle();

      // Obtener projectId y meetingId desde Vue Router
      const projectId = this.project._id;
      const meetingId = idMeeting || this.$route.params.meetingId;

      // Obtener el dominio dinámicamente
      const baseUrl = window.location.origin; // Esto devuelve "http://localhost:8080" o "https://meeting-engine.net"

      // Construir el enlace de la reunión
      const meetingLink = `${baseUrl}/p/${projectId}/meeting/${meetingId}`;

      let description = `${this.meeting.description}\n\n📅 Ver reunión: ${meetingLink}\nTemas:`;

      // Recorrer cada elemento de meetingminute.topics y concatenarlo a description
      this.meetingminute.topics.forEach((topic) => {
        description += `\n- ${topic}`;
      });

      // Agregar la URL a la descripción del evento
      console.log('fecha: ', this.meeting.fecha, ' horaInicio: ', this.meeting.horaInicio, ' horaFinal: ', this.meeting.horaFinal);
      const fecha = this.meeting.fecha.split("T")[0]; // → "2025-05-18"
      const startDateTime = new Date(`${fecha}T${this.meeting.horaInicio}:00`);
      const endDateTime = new Date(`${fecha}T${this.meeting.horaFinal}:00`);
      const event = {
        summary: this.meeting.name,
        description: description,
        start: {
          dateTime: startDateTime.toISOString(),
          timeZone: "America/Santiago",
        },
        end: {
          dateTime: endDateTime.toISOString(),
          timeZone: "America/Santiago",
        },
        attendees: this.meeting.invitados.map((email) => ({ email })),

        // Crear reunión en google meet
        conferenceData: {
          createRequest: {
            requestId: `meet-${Date.now()}`,  // Identificador único para la solicitud
            conferenceSolutionKey: {
              type: 'hangoutsMeet', // Tipo de conferencia
            }
          }
        }
      };

      console.log("📤 Enviando evento a Google Calendar...", event);

      try {
        const request = gapi.client.calendar.events.insert({
          calendarId: "primary",
          resource: event,
          conferenceDataVersion: 1, // Necesario para crear conferencias
        });

        request.execute((response) => {
          console.log("🔵 Respuesta de Google Calendar:", response);
            if (response.status === "confirmed") {
            this.$store.commit("setSnackbar", {
              color: "success",
              text: "✅ Evento agregado a Google Calendar con enlace",
            });
          } else {
            this.$store.commit("setSnackbar", {
              color: "error",
              text: "❌ Error al agregar el evento",
            });
          }
        });
      } catch (error) {
        console.error("❌ Error al agregar evento a Google Calendar:", error);
        this.$store.commit("setSnackbar", {
          color: "error",
          text: "❌ Ocurrió un error al agregar el evento.",
        });
      }
    },
    async getUsers() {
      try {
        const response = await api.post(`/api/user/getUsersByEmails`, { emails: this.meeting.invitados });
        const data = response.data;

        // Guardar los usuarios en un mapa para acceder por ID
        this.users_map = new Map();
        data.forEach(user => {
          this.users_map.set(user._id, user);
        });
        // console.debug('este es el map: ', this.users_map);
        this.$store.commit('set', { att: 'users_map', value: this.users_map });
      } catch (e) {
        console.log(e);
      }
    },
    async getMeeting() {
      // Obtener reunión
      try {
        const response = await api.get(`/api/meeting/${this.$route.params.meetingId}`);

        if (typeof response.data === 'string' && response.data === '') {
          window.location.href = `/p/${this.$route.params.projectId}/home`;
        }

        if (response.status == 200) {
          this.meeting = response.data;
          this.$store.commit("setMeeting", response.data);
          this.getUsers();

          if (this.meeting.state === "pre-meeting") {
            this.getMeetingMinute();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async goToPreMeeting() {
      console.log('gotopreemeting');
      // Verificar si es el anfitrión
      if (this.isAnfitrion || this.isSecretario) {
        try {
          // Crear la minuta de reunión
          const response = await api.post(
            `/api/meeting-minute`,
            {
              title: this.meeting.name,
              place: null, // TODO

              // Fecha
              startTime: this.meeting.fecha,
              endTime: null,

              // Horas
              startHour: this.meeting.horaInicio,
              endHour: null,

              topics: [], // Temas a hablar

              // Personas
              participants: this.meeting.invitados,
              assistants: [],
              secretaries: [this.meeting.secretario],
              leaders: [this.meeting.anfitrion],
              externals: [],

              // Datos de la reunión
              links: [],
              number: this.meeting.number,
              meeting: this.meeting._id,
              cantElementos: 0,
              comenzoReunion: false,
            }
          );
          const meetingminute = response.data;
          this.meetingminute = meetingminute;
          console.log("Meeting minute created: ", meetingminute);
          if (meetingminute._id) {
            this.$store.commit("setMeetingMinute", meetingminute);
            this.$socket.emit("event_set_new_state", {
              room: this.meeting._id,
              user: { name: `${localStorage.getItem("email")}` },
            })
          }

          // Actualizar el estado de la reunió a pre-meeting
          await api.put(`/api/meeting/${this.meeting._id}`, { state: "pre-meeting" });
        } catch (error) {
          this.$store.commit("setSnackbar", {
            color: "error",
            text: "Error al iniciar la reunión",
          });
          console.log(error);
        }
      } else {
        this.$store.commit("setSnackbar", {
          color: "error",
          text: "No tienes permisos para comenzar la reunión",
        });

        // Consultar de nuevo el estado de la reunión
        // Si el estado es pre-meeting, entonces redirigir a la vista de pre-meeting
        const responseMeetingNotAdmin = await api.get(
          `/api/meeting/${this.$route.params.meetingId}`
        );
        if (responseMeetingNotAdmin.status == 200) {
          if (responseMeetingNotAdmin.data.state == "pre-meeting") {
            //TODO revisar esto, parece que es inncesario
            this.$router.push({
              name: "MeetingWarePreMeeting",
              params: { meetingId: this.meeting._id },
            });
          }
        }
      }
    },
    // Todo: esto no debería ser necesario
    quitarUsuariosRepetidos() {
      this.users = this.users.filter(
        (user, index, self) =>
          index === self.findIndex((t) => t.name === user.name)
      );
    },
    // Inicializa la conexión WebSocket
    initSocket() {
      this.quitarUsuariosRepetidos();

      // Unirse a la sala correspondiente al ID de la reunión
      this.$socket.emit("event_join", {
        room: this.meeting._id,
        user: JSON.parse(localStorage.getItem("user")),
      });

      // Escuchar el evento 'new_state' emitido cuando el anfitrión cambia el estado
      this.$socket.on("new_state", () => {
        console.log(`[socket] new_state`, this.meeting);

        let a = this.meeting.state;
        this.meeting.state = this.lista_estados[this.step + 1];
        let b = this.meeting.state;
        console.debug(`${a} -> ${b}`);

        if (this.meeting.state === "pre-meeting") {
          // Obtener la minuta de reunión con el id de la reunión
          console.log("Obteniendo la minuta en segundo plano");
          this.getMeetingMinute();
        }
      });

      // Escuchar el evento 'connected_users' para obtener la lista de usuarios conectados al unirse
      this.$socket.on("connected_users", (users) => {
        // console.log('Obteniendo usuarios conectados: ', users);
        this.users = users; // Actualizar la lista de usuarios conectados
        this.$store.commit('set', { att: 'conected_users', value: users })

        // Quitar repetidos
        this.quitarUsuariosRepetidos();
      });

      // Escuchar el evento 'new_user' para cuando un usuario se conecta
      this.$socket.on("new_user", (user) => {
        this.users.push(user); // Agregar nuevo usuario conectado a la lista
        this.quitarUsuariosRepetidos();
      });

      // Escuchar el evento 'left_user' para cuando un usuario se desconecta
      this.$socket.on("left_user", (user) => {
        this.quitarUsuariosRepetidos();
        // Buscar si el usuario ya existe
        const found = this.users.find((u) => u.name === user.name);
        if (!found) return;
        this.users = this.users.filter((u) => u.name !== user.name); // Eliminar usuario desconectado
      });
    },

    async getMeetingMinute() {
      try {
        const response = await api.get(
          `/api/meeting-minute/meeting/${this.meeting._id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.data) {
          this.meetingminute = response.data;
          this.$store.commit("setMeetingMinute", response.data);
        }
      } catch (e) {
        console.log(e);

      }
    },
    async updateMeetingState(mode) {
      // Validar si tiene el rol correspondiente
      if (!this.isAnfitrion && !this.isSecretario) {
        console.log("isAnfitrion: ", this.isAnfitrion);
        this.$store.commit("setSnackbar", {
          color: "error",
          text: "No tienes permiso para cambiar el estado de la reunión",
        });
        return;
      }

      // Validar que hayan temas en la minuta
      if (this.meetingminute.topics.length === 0 && this.step === 1) {
        this.$store.commit("setSnackbar", {
          color: "error",
          text: "No hay temas en la minuta",
        });
        return;
      }

      var delta = mode === 'back' ? -1 : 1;
      const newState = this.lista_estados[Number(this.step + delta)];
      // Actualizar el estado de la reunión
      try {
        var objMeeting = {
          state: newState,
        };

        // Actualizar reunión
        await api.put(`/api/meeting/${this.meeting._id}`, objMeeting);

        // Actualizar minuta
        if (newState === "in-meeting") {
          var objMinute = {
            realStartTime: new Date(),
            comenzoReunion: true,
          };

          const response2 = await api.put(`/api/meeting-minute/${this.meetingminute._id}`, objMinute);
          this.meetingminute = response2.data;

          // Agregar evento a Google Calendar
          await this.addToGoogleCalendar(this.meeting._id);
        }

        if (newState === "post-meeting") {
          // Actualizar minuta
          var objMinute2 = {
            realEndTime: new Date(),
            comenzoReunion: false,
          };

          const response2 = await api.put(`/api/meeting-minute/${this.meetingminute._id}`, objMinute2);
          this.meetingminute = response2.data;
        }

        // Emitir evento al servidor para notificar a los demás usuarios
        this.$socket.emit("event_set_new_state", {
          room: this.meeting._id,
          user: { name: `${localStorage.getItem("email")}` },
        });
        console.log('emitiendo evento', this.meeting._id);

        this.getMeeting();

        console.log("Reunión iniciada");
      } catch (e) {
        console.log(e);

      }
    },


    // Función que obtenga los compromisos previos de la reunión
    async getCompromisosPrevios() {
      // Fecha de la reunión.
      const fecha = this.meetingminute.startTime || this.meeting.fecha;
      // Endpoint que llama a los compromisos previos desde el projectId y la fecha de la reunión.
      try {
        const response = await api.get(`/api/element/project/${this.$route.params.projectId}/compromisos/${fecha}`);

        // Se preparan los datos necesarios, en el formato adecuado
        const data = await Promise.all(response.data.map(async (compromiso) => ({
          number: compromiso.number,
          description: compromiso.description.replace(/^(Compromiso):\s*/i, ''),
          state: compromiso.state,
        })));

        // Retorno de datos
        return data;

      } catch (e) {
        console.log(e);
      }
    },

    // Función que obtenga la información del proyecto actual para mostrarlo en el acta (el nombre del proyecto y su tag o nombre de aplicación)
    async getProjectCurrent() {
      try {
        const response = await api.get(
          `/api/project/getProjectbyID/${this.$route.params.projectId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        return response.data;
      } catch (e) {
        console.log(e);
      }
    },

    //-----------------------------------------------------
    // Función modificada para agregar nuevo formato PDF
    //-----------------------------------------------------
    async exportToPDF() {
      // --- Datos y documento ---
      const dataElementsMeeting = await this.$refs.postMeetingComponent.getTopicsWithElementsAsync();
      const compromisosPrevios = await this.getCompromisosPrevios();
      const infoProject = await this.getProjectCurrent();
      const meeting = this.meeting;
      const doc = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'letter' });

      // --- Constantes generales ---
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margins = { left: 40, right: 40, top: 40, bottom: 40 };
      const lineHeight = 20;
      const footerHeight = 40;
      const sectionPadding = 15;
      const subsectionPadding = 8;
      const boxRadius = 6;
      const minBottomSpace = footerHeight + 10;
      let cursorY = margins.top;

      // --- Colores y estilos ---
      const colors = {
        titleBg: [215, 225, 240],
        sectionBg: [215, 225, 240],
        subsectionBg: [240, 240, 240],
        sectionText: [52, 73, 94],
        text: [33, 37, 41],
        footerText: [100],
      };

      const getTipoColor = (tipo) => {
        switch (tipo.toLowerCase()) {
          case 'compromiso': return [33, 150, 243];    // azul
          case 'duda': return [255, 193, 7];     // ámbar
          case 'acuerdo': return [76, 175, 80];     // verde
          case 'desacuerdo': return [244, 67, 54];     // rojo
          case 'texto libre': return [158, 158, 158];  // gris
          case 'votacion': return [128, 0, 128];       // Morado
          default: return [96, 125, 139];    // gris azul
        }
      };

      // --- Reseteo de fuentes por cada nueva página ---
      const resetFont = () => {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(12);
        doc.setTextColor(...colors.text);
      };

      // --- Pie de página ---
      const drawFooter = () => {
        const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
        const y = pageHeight - footerHeight + 10;
        doc.setDrawColor(200);
        doc.line(margins.left, y - 10, pageWidth - margins.right, y - 10);
        doc.setFontSize(10);
        doc.setTextColor(...colors.footerText);
        doc.text(`Generado automáticamente con ${infoProject.tabName || infoProject.name}`, margins.left, y);
        doc.text(`${currentPage}`, pageWidth - margins.right, y, { align: 'right' });
      };

      // --- Comprobar espacio ---
      const checkSpace = (height) => {
        if (cursorY + height + minBottomSpace > pageHeight) {
          drawFooter();
          doc.addPage();
          cursorY = margins.top;
          resetFont();
        }
      };

      // --- Formato de fecha local (nota: retorna la fecha según la zona horaria actual)---
      // Entrada: '2023-10-01T00:00:00Z'
      // Salida: '01 de octubre de 2023'
      const formatDate = (dateStr) =>
        new Date(dateStr).toLocaleDateString('es-ES', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        });
      
      // --- Otro formato de fecha (nota: no usa la zona horaria actual, solo el dato de la fecha) ---
      // Entrada: '2025-10-23'
      // Salida: '23 de noviembre de 2025'
      // const formatDate2 = (dateStr) => {
      //   const [year, month, day] = dateStr.split('-');
      //   return `${day} de ${new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(new Date(year, month - 1))} de ${year}`;
      // };

      // --- Título del documento ---
      const titleSectionHeight = 100;
      const centerY = titleSectionHeight / 2;
      doc.setFillColor(...colors.titleBg);
      doc.roundedRect(0, 0, pageWidth, titleSectionHeight, 0, 0, 'F');

      // Título principal (menos negrita)
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(18);
      doc.setTextColor(0, 0, 0);
      doc.text('Acta dialógica de reunión', pageWidth / 2, centerY - 20, {
        align: 'center',
        baseline: 'middle'
      });

      // Subtítulo indicando el número y nombre de la reunión (más destacado)
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(22);
      doc.text(`${meeting.number}. ${meeting.name}`, pageWidth / 2, centerY + 4, {
        align: 'center',
        baseline: 'middle'
      });

      // Subtitulo indicando el nombre del proyecto (mismo estilo que título principal)
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(16);
      doc.text(`${infoProject.name}`, pageWidth / 2, centerY + 28, {
        align: 'center',
        baseline: 'middle'
      });

      // Mover el cursor para el contenido que viene después
      cursorY = titleSectionHeight + 20;
      resetFont();

      // --- Título de sección ---
      const drawSectionTitle = (text) => {
        const height = 30;
        checkSpace(height);
        doc.setFillColor(...colors.sectionBg);
        doc.roundedRect(margins.left, cursorY, pageWidth - margins.left - margins.right, height, 5, 5, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        doc.setTextColor(...colors.sectionText);
        doc.text(text, margins.left + sectionPadding, cursorY + 20);
        cursorY += height + 4;
        resetFont();
      };

      // --- Subsección con borde redondeado que puede dividirse en páginas ---
      const drawSectionWithRoundedBorder = (sectionTitle, subsections, sectionIndex) => {
        const sectionPad = 4;
        const borderRadius = 8;
        const borderBlocks = [];

        const originalAddPage = doc.addPage.bind(doc);
        doc.addPage = function (...args) {
          drawFooter();
          originalAddPage(...args);
          resetFont();
          cursorY = margins.top;
        };

        const sectionStartPage = doc.internal.getCurrentPageInfo().pageNumber;
        const sectionStartY = cursorY;

        drawSectionTitle(sectionTitle);
        let blockStartY = cursorY;

        subsections.forEach(subsection => {
          const maxWidth = pageWidth - margins.left - margins.right - subsectionPadding * 2;

          const titleLines = doc.splitTextToSize(subsection.title, maxWidth);

          const contentLines = Array.isArray(subsection.content)
            ? subsection.content.flatMap(line => {
              if (
                sectionIndex === 2 &&
                typeof line === 'object' &&
                line.label && line.tipo && line.autor
              ) {
                return [line]; // mantener objeto, lo trataremos como línea especial
              } else {
                return doc.splitTextToSize(line, maxWidth); // texto normal
              }
            })
            : [];

          const allLines = [...titleLines, ...contentLines];

          while (allLines.length > 0) {
            const availableHeight = pageHeight - cursorY - minBottomSpace;
            const linesFit = Math.floor((availableHeight - subsectionPadding * 2) / lineHeight);

            if (linesFit < 1) {
              borderBlocks.push({
                page: doc.internal.getCurrentPageInfo().pageNumber,
                startY: blockStartY,
                endY: pageHeight - minBottomSpace
              });
              doc.addPage();
              blockStartY = cursorY;
              continue;
            }

            const blockLines = allLines.splice(0, linesFit);
            const boxHeight = blockLines.length * lineHeight + subsectionPadding * 2;
            const yStart = cursorY;

            doc.setFillColor(...colors.subsectionBg);
            doc.roundedRect(
              margins.left,
              yStart,
              pageWidth - margins.left - margins.right,
              boxHeight,
              boxRadius,
              boxRadius,
              'F'
            );

            let yText = yStart + subsectionPadding + 14;

            blockLines.forEach(line => {
              const isTitle = line === subsection.title;
              doc.setFont(undefined, isTitle ? 'bold' : 'normal');

              if (
                sectionIndex === 2 &&
                typeof line === 'object' &&
                line.label && line.tipo && line.autor
              ) {
                const labelText = line.label;
                const tipo = line.tipo;
                const autor = line.autor;

                const tipoColor = getTipoColor(tipo);

                // Calcular anchos
                const labelWidth = doc.getTextWidth(labelText);
                const tipoWidth = doc.getTextWidth(tipo) + 6;

                const startX = margins.left + subsectionPadding;

                // Calcular la altura del texto normal (que es de tamaño 12)
                const textHeight = 16;  // Ajuste manual de la altura del texto normal

                // Dibuja el label
                doc.text(labelText, startX, yText);

                // Dibuja la etiqueta coloreada
                const tipoHeight = textHeight; // Altura igual a la altura del texto
                doc.setFillColor(...tipoColor);
                doc.setTextColor(255, 255, 255);

                // Ajuste para mover la etiqueta hacia arriba
                const verticalOffset = -4; // Cambia este valor para mover la etiqueta hacia arriba o abajo

                // Dibuja el rectángulo para la etiqueta con la altura del texto
                doc.roundedRect(startX + labelWidth + 4, yText - (tipoHeight / 2) + verticalOffset, tipoWidth, tipoHeight, 2, 2, 'F');
                doc.text(tipo, startX + labelWidth + 7, yText);

                // Dibuja el autor
                doc.setTextColor(0, 0, 0);
                doc.text(autor, startX + labelWidth + tipoWidth + 8, yText);

              } else {
                // Línea normal
                doc.setTextColor(0, 0, 0);
                doc.text(line, margins.left + subsectionPadding, yText);
              }

              yText += lineHeight;
            });

            cursorY += boxHeight + 4;
          }
        });

        doc.addPage = originalAddPage;
        //drawFooter();
        resetFont();

        borderBlocks.push({
          page: doc.internal.getCurrentPageInfo().pageNumber,
          startY: blockStartY,
          endY: cursorY
        });

        borderBlocks.forEach(({ page, startY, endY }) => {
          doc.setPage(page);
          const isFirstPage = page === sectionStartPage;
          const y = isFirstPage ? sectionStartY - sectionPad : startY - sectionPad;
          const height = (endY - (isFirstPage ? sectionStartY : startY)) + sectionPad * 2;

          doc.setDrawColor(176, 176, 176);
          doc.setLineWidth(0.5);
          doc.roundedRect(
            margins.left - sectionPad,
            y,
            pageWidth - margins.left - margins.right + sectionPad * 2,
            height,
            borderRadius,
            borderRadius
          );
        });

        const lastBlock = borderBlocks[borderBlocks.length - 1];
        doc.setPage(lastBlock.page);
        cursorY = lastBlock.endY;
        resetFont();
      };

      // Uso de las funciones de dibujo por cada sección
      // --- Sección 1: Datos de la reunión ---
      drawSectionWithRoundedBorder('Datos de la reunión', [
        {
          title: 'Información general',
          content: [
            `Número: ${meeting.number}`,
            `Nombre: ${meeting.name}`,
            `Descripción: ${meeting.description}`,
          ]
        },
        {
          title: 'Horario planificado',
          content: [
            `Fecha: ${(() => {
              console.debug('fecha planificado to pdf:', meeting.fecha);
              return formatDate(meeting.fecha);
            })()}`,
            `Hora de inicio: ${meeting.horaInicio}`,
            `Hora de finalización: ${meeting.horaFinal}`,
          ]
        },
        {
          title: 'Horario real',
          content: [
            `Fecha: ${
            (() => {
              console.debug('fecha real to pdf: ', this.meetingminute.realStartTime);
              return formatDate(this.meetingminute.realStartTime)
            })()
            }`,
            `Hora de inicio: ${formatDateTimeToTime(this.meetingminute.realStartTime)}`,
            `Hora de finalización: ${formatDateTimeToTime(this.meetingminute.realEndTime)}`,
          ]
        },
        {
          title: 'Responsables y Participantes',
          content: [
            `Anfitrión: ${meeting.anfitrion}`,
            `Secretario/a: ${meeting.secretario}`,
            'Participantes:',
            ...meeting.invitados.map(p => `- ${p}`)
          ]
        }
      ], 0);

      cursorY += 20;

      // --- Sección 2: Compromisos previos (solo si no es la reunión 0) ---
      if (this.meeting?.number !== 0) {
        drawSectionWithRoundedBorder('Compromisos previos',
          compromisosPrevios.length
            ? compromisosPrevios.map(c => ({
              title: `1.${c.number}`,
              content: [
                `Estado: ${c.state}`,
                `${c.description}`
              ]
            }))
            : [{
              title: '(Datos no disponibles)',
              content: []
            }]
          , 1);
        cursorY += 20;
      }

      // --- Sección 3: Desarrollo de la reunión ---
      drawSectionWithRoundedBorder('Desarrollo de la reunión',
        !dataElementsMeeting?.length
          ? [{ title: '(Datos no disponibles)', content: [] }]
          : dataElementsMeeting.map((topic, idx) => ({
            title: `${idx + 1}: ${topic.topicTitle}`,
            content: (topic.elements || []).flatMap((el, elIdx) => {
              const label = `${idx + 1}.${elIdx + 1}`;
              const tipo = el.type;
              const autor = `Escrito por ${el.autor}:`;

              // Si el elemento es votación, se muestra los votos
              if (tipo === 'votación' || tipo === 'votacion') {
                return [
                  { label, tipo, autor },  // esto activa el render especial
                  el.description,          // contenido normal
                  `Si: ${el.votos[0]}      No: ${el.votos[1]}`, // Votos
                  ''                       // espaciado
                ];
              } else {
                return [
                  { label, tipo, autor },  // esto activa el render especial
                  el.description,          // contenido normal
                  ''                       // espaciado
                ];
              }
            })
          }))
        , 2);

      // --- Pie de página final ---
      drawFooter();

      // --- Guardar el PDF ---
      const filename = `(${meeting.number})_${meeting.name}.pdf`;
      doc.save(filename);
    },


    async exit() {
      await this.exportToPDF();
    },
  },
  async created() {
    this.loadGoogleAPI();
    await this.getMeeting();

    if (localStorage.getItem("email") === this.meeting.anfitrion) {
      this.isAnfitrion = true;
    }

    this.initSocket();
    await this.getMeetingMinute();
  },
};
</script>

<style scoped>
.body-div {
  display: flex;
  justify-content: center;
  overflow-y: auto;
  height: 100vh;
  width: 100%;
}

.fila0 h1 {
  
}

.green {
  background-color: #14B8A6;
}
</style>
